__turbopack_context__.v({
  "ecgChartOffset": "VitalsPopupHandle-module__hhVOVG__ecgChartOffset",
  "heart-rate-fade-in": "VitalsPopupHandle-module__hhVOVG__heart-rate-fade-in",
  "heartRate": "VitalsPopupHandle-module__hhVOVG__heartRate",
  "root": "VitalsPopupHandle-module__hhVOVG__root",
});
